// extracted by mini-css-extract-plugin
export default {"upload":"style_upload__t422Q__WHx6O","upload-list":"style_upload-list__Q9HDc__WHx6O","upload-input":"style_upload-input__vXk4w__WHx6O","tips":"style_tips__3Gpnu__WHx6O"};